<template>
    <!-- 上传图片
         @author: 王汝鹏
         @date: 2019-9-16
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :rules="validatorRule"
                     :variableName="model"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-upload class="form-item_upload"
                 :class="{'is-limited': showFileListData.length >= uploadLimit}"
                 :action="uploadHost"
                 :limit="uploadLimit"
                 :http-request="uploadImage"
                 :on-remove="handleRemove"
                 :on-exceed="handleExceed"
                 :file-list="showFileListData">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
  </preview-form-item>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixUpload 上传图片/文件混入
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import mixUpload from '@/mixins/common/mix_upload.js';
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [
    mixUpload,
    mixPreviewItemTemplateChild
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemUploadFile.vue